import React, {useEffect, useState} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {InputMask} from 'primereact/inputmask';
import {Checkbox} from 'primereact/checkbox';
import {Button} from 'primereact/button';
import {Panel} from 'primereact/panel';
import {Message} from 'primereact/message';
import {Link} from 'react-router-dom';
import axios from 'axios';

const RegisterPage = (props) => {
  const {t} = props;
  const locale = process.env.REACT_APP_LOCALE || '';
  const isHungarianLocale = locale.toLowerCase().startsWith('hu');
  const isFrontendRegistrationEnabled = ['enabled', 'true'].includes(
    (process.env.REACT_APP_REGISTRATION || '').toLowerCase()
  );
  const privacyUrl = process.env.REACT_APP_REGISTRATION_PRIVACY_URL || '#';
  const termsUrl = process.env.REACT_APP_REGISTRATION_TERMS_URL || '#';
  const initialValues = {
    name: '',
    email: '',
    tax_number: '',
    privacyAccepted: false,
    termsAccepted: false
  };

  const [availabilityLoading, setAvailabilityLoading] = useState(true);
  const [registrationAvailable, setRegistrationAvailable] = useState(false);
  const [registrationError, setRegistrationError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sentEmail, setSentEmail] = useState('');

  const isRegistrationAvailable = (data) => {
    if (typeof data === 'boolean') {
      return data;
    }

    if (typeof data === 'string') {
      const normalized = data.toLowerCase();
      return normalized === 'true' || normalized === 'enabled' || normalized === 'available';
    }

    if (data === '' || data === null || typeof data === 'undefined') {
      return false;
    }

    if (!data || typeof data !== 'object') {
      return false;
    }

    if (Array.isArray(data)) {
      return false;
    }

    if (typeof data.available === 'boolean') {
      return data.available;
    }
    if (typeof data.enabled === 'boolean') {
      return data.enabled;
    }
    if (typeof data.registrationAvailable === 'boolean') {
      return data.registrationAvailable;
    }
    if (Object.prototype.hasOwnProperty.call(data, 'data')) {
      return isRegistrationAvailable(data.data);
    }

    return false;
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  const validate = (data) => {
    let errors = {};

    if (!data.name) {
      errors.name = 'A név megadása kötelező!';
    }
    if (!data.email) {
      errors.email = 'Az email mező nem lehet üres.';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(data.email)) {
      errors.email = 'Mindenképpen email formátumra van szükség! Pl. example@email.com';
    }
    if (!data.tax_number) {
      errors.tax_number = 'Az adószám megadása kötelező!';
    } else if (isHungarianLocale && !/^\d{8}-\d-\d{2}$/.test(data.tax_number)) {
      errors.tax_number = 'Magyar adószám formátum szükséges: 12345678-9-01';
    }
    if (data.privacyAccepted !== true) {
      errors.privacyAccepted = 'Az Adatvédelmi nyilatkozat elfogadása kötelező!';
    }
    if (data.termsAccepted !== true) {
      errors.termsAccepted = 'Az Általános szerződési feltételek elfogadása kötelező!';
    }

    return errors;
  };

  const onSubmit = (data) => {
    setLoading(true);
    setRegistrationError('');

    axios.post(process.env.REACT_APP_API_HOST + '/api/v2/registration', {
      name: data.name,
      email: data.email,
      tax_number: data.tax_number
    })
      .then(response => {
        setSentEmail(response.data && response.data.data && response.data.data.email ? response.data.data.email : data.email);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        setRegistrationError('Hiba történt a regisztráció során.');
        if (window.App && typeof window.App.toastShow === 'function') {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        }
      });
  };

  useEffect(() => {
    document.title = 'Regisztráció' + ' - ' + process.env.REACT_APP_TITLE;
    document.getElementById('body').classList.add('outside');

    if (!isFrontendRegistrationEnabled) {
      setRegistrationAvailable(false);
      setRegistrationError('A regisztráció nem elérhető');
      setAvailabilityLoading(false);
      return;
    }

    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/registration/availability')
      .then(response => {
        const available = response.status >= 200
          && response.status < 300
          && isFrontendRegistrationEnabled
          && isRegistrationAvailable(response.data);
        setRegistrationAvailable(available);
        setRegistrationError(available ? '' : 'A regisztráció nem elérhető');
        setAvailabilityLoading(false);
      })
      .catch(() => {
        setRegistrationAvailable(false);
        setRegistrationError('A regisztráció nem elérhető');
        setAvailabilityLoading(false);
      });
  }, []);

  return (
    <div className="LoginPage RegistrationPage p-component p-p-3">
      <img src={require("../.." + process.env.REACT_APP_LOGO_FILE).default} className="p-d-block p-my-5 p-mx-auto"/>
      <Panel headerTemplate={
        <div className={"p-grid"}>
          <div className={"p-col-12"}>
            <h3>
              <i className={"pi pi-user-plus"}></i> Regisztráció
            </h3>
          </div>
        </div>
      }>
        {availabilityLoading && (
          <Message severity="info" text="Regisztráció elérhetőségének ellenőrzése..." className={"w-100"}/>
        )}

        {!availabilityLoading && !registrationAvailable && (
          <>
            <Message severity="error" text={registrationError || 'A regisztráció nem elérhető'} className={"w-100"}/>
            <div className={"p-mt-4"}>
              <Link to={"/login"}>Bejelentkezés</Link>
            </div>
          </>
        )}

        {!availabilityLoading && registrationAvailable && sentEmail && (
          <>
            <Message
              severity="success"
              text={`A regisztráció következő lépéséhez szükséges információkat elküldtük a(z) ${sentEmail} email címre.`}
              className={"w-100"}
            />
            <div className={"p-mt-4"}>
              <Link to={"/login"}>Bejelentkezés</Link>
            </div>
          </>
        )}

        {!availabilityLoading && registrationAvailable && !sentEmail && (
          <Form onSubmit={onSubmit}
                className="p-d-block p-mt-5 p-mx-auto"
                initialValues={initialValues}
                validate={validate}
                render={({handleSubmit, submitting, pristine, invalid}) => (
            <form onSubmit={handleSubmit}>
              {registrationError && (
                <Message severity="error" text={registrationError} className={"w-100 p-mb-3"}/>
              )}
              <div className={"p-grid p-mt-1"}>
                <div className={"p-col-12"}>
                  <Field name="name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="name" className={classNames({'p-error': isFormFieldValid(meta)})}>{t('nameRequired')}</label>
                      <span className="p-input-icon-right">
                        <i className="pi pi-user"/>
                        <InputText id="name" {...input} className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12"}>
                  <Field name="email" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="email" className={classNames({'p-error': isFormFieldValid(meta)})}>{t('emailRequired')}</label>
                      <span className="p-input-icon-right">
                        <i className="pi pi-envelope"/>
                        <InputText id="email" {...input} className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12"}>
                  <Field name="tax_number" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="tax_number" className={classNames({'p-error': isFormFieldValid(meta)})}>{t('taxNumberRequired')}</label>
                      <span className="p-input-icon-right">
                        <i className="pi pi-id-card"/>
                        {isHungarianLocale ? (
                          <InputMask id="tax_number"
                                     {...input}
                                     mask="99999999-9-99"
                                     placeholder={t('taxNumberExamplePlaceholder')}
                                     onChange={(e) => input.onChange(e.value)}
                                     className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                        ) : (
                          <InputText id="tax_number" {...input} className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                        )}
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12"}>
                  <Field name="privacyAccepted" type="checkbox" render={({input, meta}) => (
                    <div className="p-field-checkbox">
                      <Checkbox inputId="privacyAccepted"
                                checked={input.checked}
                                onChange={(e) => input.onChange(e.checked)}/>
                      <label htmlFor="privacyAccepted" className={classNames({'p-error': isFormFieldValid(meta)})}>
                        Elfogadom az <a href={privacyUrl} target="_blank" rel="noopener noreferrer">Adatvédelmi nyilatkozatot</a>
                      </label>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12"}>
                  <Field name="termsAccepted" type="checkbox" render={({input, meta}) => (
                    <div className="p-field-checkbox">
                      <Checkbox inputId="termsAccepted"
                                checked={input.checked}
                                onChange={(e) => input.onChange(e.checked)}/>
                      <label htmlFor="termsAccepted" className={classNames({'p-error': isFormFieldValid(meta)})}>
                        Elfogadom az <a href={termsUrl} target="_blank" rel="noopener noreferrer">Általános szerződési feltételeket</a>
                      </label>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
              </div>
              <div className={"p-grid p-mt-2"}>
                <div className={"p-col-12 p-lg-6"}>
                  <Link to={"/login"}>Bejelentkezés</Link>
                </div>
                <div className={"p-col-12 p-lg-6 p-text-right"}>
                  <Button type="submit"
                          label={t('registration')}
                          className="p-button-success"
                          icon={"pi pi-check"}
                          loading={loading}
                          disabled={submitting || loading || pristine || invalid}/>
                </div>
              </div>
            </form>
          )}/>
        )}
        <div className={"p-text-center p-mt-5"}>
          <span className={"p-text-secondary"}
                dangerouslySetInnerHTML={{__html: process.env.REACT_APP_COPYRIGHT.replace('[[YEAR]]', new Date().getFullYear())}}></span>
        </div>
      </Panel>
    </div>
  );
};

export default withTranslation('common')(RegisterPage);
